<div class="container">
  <sca-module-title class="title-test">
    <h1>Authentication Playground Completo</h1>
    <span scaModuleTitlePost>Testing exhaustivo de @argo/authentication - {{ coverage }}% de cobertura</span>
  </sca-module-title>

  <!-- 1. ESTADO Y FASE -->
  <section class="card">
    <h2>Estado y Fase de Autenticación (AuthPhase)</h2>
    <div class="status-grid">
      <sca-card-workshop [selected]="auth.phase() === AuthPhase.ANONYMOUS">
        <header scaCardWorkshopHeader>
          <sca-badge variant="white" [rounded]="false">Sin sesión</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Sin token válido</p>
        <p scaCardWorkshopAddress>ANONYMOUS</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="auth.phase() === AuthPhase.AUTHENTICATING">
        <header scaCardWorkshopHeader>
          <sca-badge variant="warning" [rounded]="false">Autenticando...</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Resolviendo Code Flow</p>
        <p scaCardWorkshopAddress>AUTHENTICATING</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="auth.phase() === AuthPhase.AUTHENTICATED_NORMAL">
        <header scaCardWorkshopHeader>
          <sca-badge variant="success" [rounded]="false">Autenticado OK</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Token válido y lejano</p>
        <p scaCardWorkshopAddress>NORMAL</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="auth.phase() === AuthPhase.AUTHENTICATED_ALMOST_EXPIRED">
        <header scaCardWorkshopHeader>
          <sca-badge variant="warning" [rounded]="false">Por expirar</sca-badge>
        </header>
        <p scaCardWorkshopTitle>≤20% vida del token</p>
        <p scaCardWorkshopAddress>ALMOST EXPIRED</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="auth.phase() === AuthPhase.REFRESHING">
        <header scaCardWorkshopHeader>
          <sca-badge variant="default" [rounded]="false">Refrescando...</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Ejecutando refresh</p>
        <p scaCardWorkshopAddress>REFRESHING</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="auth.phase() === AuthPhase.EXPIRED">
        <header scaCardWorkshopHeader>
          <sca-badge variant="error" [rounded]="false">Token expirado</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Refresh fallido</p>
        <p scaCardWorkshopAddress>EXPIRED</p>
      </sca-card-workshop>
    </div>
    <!-- <div class="phase-info">
      <p><strong>Fase actual:</strong> <code>{{ auth.phase() }}</code></p>
    </div> -->
  </section>

  <!-- 2. SIGNALS Y COMPUTED -->
  <section class="card">
    <h2>Signals y Computed Properties</h2>
    <sca-alert variant="info">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Todas las propiedades reactivas del AuthenticationStore
      
    </sca-alert>
    <table class="properties-table">
      <thead>
        <tr>
          <th>Propiedad</th>
          <th>Tipo</th>
          <th>Valor Actual</th>
          <th>Descripción</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><code>logged()</code></td>
          <td>Signal&lt;boolean&gt;</td>
          <td><span [class]="auth.logged() ? 'value-true' : 'value-false'">{{ auth.logged() }}</span></td>
          <td>¿Hay token válido?</td>
        </tr>
        <tr>
          <td><code>isAuthenticated()</code></td>
          <td>Computed&lt;boolean&gt;</td>
          <td><span [class]="auth.isAuthenticated() ? 'value-true' : 'value-false'">{{ auth.isAuthenticated() }}</span></td>
          <td>¿Está en fase authenticated.*?</td>
        </tr>
        <tr>
          <td><code>isAuthenticating()</code></td>
          <td>Computed&lt;boolean&gt;</td>
          <td><span [class]="auth.isAuthenticating() ? 'value-true' : 'value-false'">{{ auth.isAuthenticating() }}</span></td>
          <td>¿Está autenticando?</td>
        </tr>
        <tr>
          <td><code>isRefreshing()</code></td>
          <td>Computed&lt;boolean&gt;</td>
          <td><span [class]="auth.isRefreshing() ? 'value-true' : 'value-false'">{{ auth.isRefreshing() }}</span></td>
          <td>¿Está refrescando token?</td>
        </tr>
        <tr>
          <td><code>almostExpired()</code></td>
          <td>Signal&lt;boolean&gt;</td>
          <td><span [class]="auth.almostExpired() ? 'value-warning' : 'value-false'">{{ auth.almostExpired() }}</span></td>
          <td>¿Token en últimos 20%?</td>
        </tr>
        <tr>
          <td><code>secondsToLogout()</code></td>
          <td>Signal&lt;number&gt;</td>
          <td><span class="value-number">{{ auth.secondsToLogout() }}s</span></td>
          <td>Segundos hasta logout</td>
        </tr>
        <tr>
          <td><code>tokenRemainingMs()</code></td>
          <td>Signal&lt;number&gt;</td>
          <td><span class="value-number">{{ auth.tokenRemainingMs() }}ms</span></td>
          <td>Milisegundos restantes</td>
        </tr>
        <tr>
          <td><code>tokenRemainingSeconds()</code></td>
          <td>Computed&lt;number&gt;</td>
          <td><span class="value-number">{{ auth.tokenRemainingSeconds() }}s</span></td>
          <td>Segundos (derivado de ms)</td>
        </tr>
        <tr>
          <td><code>phase()</code></td>
          <td>Signal&lt;AuthPhase&gt;</td>
          <td><span class="value-enum">{{ auth.phase() }}</span></td>
          <td>Fase actual del ciclo</td>
        </tr>
        <tr>
          <td><code>user()</code></td>
          <td>Signal&lt;AuthUser|null&gt;</td>
          <td><span [class]="auth.user() ? 'value-object' : 'value-null'">{{ auth.user() ? 'Object' : 'null' }}</span></td>
          <td>Datos del usuario</td>
        </tr>
      </tbody>
    </table>
  </section>

  <!-- 3. INFORMACIÓN DEL USUARIO -->
  <section class="card" *ngIf="auth.logged() && auth.user()">
    <h2>Información Completa del Usuario (AuthUser)</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Todos los campos del modelo AuthUser extraídos del token
      
    </sca-alert>
    <div class="utilities-grid">
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="email" size="24px" />
        <span scaCardClaimTitle>Email</span>
        <span scaCardClaimDate>{{ auth.user()!.email || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="person" size="24px" />
        <span scaCardClaimTitle>Nombre</span>
        <span scaCardClaimDate>{{ auth.user()!.given_name || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="people" size="24px" />
        <span scaCardClaimTitle>Apellido</span>
        <span scaCardClaimDate>{{ auth.user()!.family_name || 'N/A' }}</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="badge" size="24px" />
        <span scaCardClaimTitle>Nombre Completo</span>
        <span scaCardClaimDate>{{ auth.user()!.name || 'N/A' }}</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="account_circle" size="24px" />
        <span scaCardClaimTitle>Username</span>
        <span scaCardClaimDate>{{ auth.user()!.preferred_username || 'N/A' }}</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="business" size="24px" />
        <span scaCardClaimTitle>Compañía</span>
        <span scaCardClaimDate>{{ auth.user()!.company || 'N/A' }}</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="work" size="24px" />
        <span scaCardClaimTitle>Cargo/Título</span>
        <span scaCardClaimDate>{{ auth.user()!.title || 'N/A' }}</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="description" size="24px" />
        <span scaCardClaimTitle>Descripción</span>
        <span scaCardClaimDate>{{ auth.user()!.description || 'N/A' }}</span>
      </sca-card-claim>
    </div>
    
    <sca-view-more
      [collapsedText]="collapsedText"
      [expandedText]="expandedText"
      [isExpanded]="isExpanded"
    >
      <pre>{{ auth.user() | json }}</pre>
    </sca-view-more>
  </section>

  <sca-alert variant="warning" *ngIf="!auth.logged()">
    <sca-icon icon="info" size="24px" [weight]="300" left />
    Inicia sesión para ver la información completa del usuario
    
  </sca-alert>

  <!-- 4. ROLES Y PERMISOS -->
  <section class="card" *ngIf="auth.logged()">
    <h2>Roles y Permisos (getUserRoles)</h2>
    <sca-alert variant="info">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Roles extraídos del claim 'roles' del token
      
    </sca-alert>
    <div class="roles-container">
      <span class="role-badge" *ngFor="let role of userRoles()">
        🎭 {{ role }}
      </span>
      <div class="alert alert-warning" *ngIf="userRoles().length === 0">
        Sin roles asignados
      </div>
    </div>
  </section>

  <!-- 5. TOKENS (Access & ID) -->
  <section class="card" *ngIf="auth.logged()">
    <h2>Tokens JWT (getToken & getIdToken)</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Access Token y ID Token para debugging y llamadas API
      
    </sca-alert>
    
    <div class="token-section">
      <div class="token-block">
        <label>Access Token</label>
        <div class="token-actions">
          <button sca-button variant="border" size="small" (click)="copyToClipboard(accessToken(), 'Access Token')">
            <sca-icon icon="content_copy" size="16px" [weight]="300" left />
            Copiar
          </button>
          <button sca-button variant="border" size="small" (click)="decodeToken(accessToken())">
            <sca-icon icon="lock_open" size="16px" [weight]="300" left />
            Decodificar
          </button>
        </div>
        <textarea readonly class="token-display">{{ accessToken() }}</textarea>
        <p class="token-length">Longitud: {{ accessToken().length }} caracteres</p>
      </div>

      <div class="token-block">
        <label>ID Token</label>
        <div class="token-actions">
          <button sca-button variant="border" size="small" (click)="copyToClipboard(idToken(), 'ID Token')">
            <sca-icon icon="content_copy" size="16px" [weight]="300" left />
            Copiar
          </button>
          <button sca-button variant="border" size="small" (click)="decodeToken(idToken())">
            <sca-icon icon="lock_open" size="16px" [weight]="300" left />
            Decodificar
          </button>
        </div>
        <textarea readonly class="token-display">{{ idToken() }}</textarea>
        <p class="token-length">Longitud: {{ idToken().length }} caracteres</p>
      </div>
    </div>

    <sca-alert variant="info" *ngIf="decodedToken()">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      <details>
        <summary><strong>Token Decodificado:</strong></summary>
        <pre>{{ decodedToken() | json }}</pre>
      </details>
      
    </sca-alert>
  </section>

  <!-- 6. PROGRESO DEL TOKEN -->
  <section class="card" *ngIf="auth.logged()">
    <h2>Vida del Token (Progress Bar)</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Visualización en tiempo real del tiempo restante del token
      
    </sca-alert>
    <div class="progress-container">
      <sca-progress-bar [value]="tokenPercentage()" />
      <div class="progress-info">
        <p>
          <strong>{{ auth.tokenRemainingSeconds() }}s</strong> restantes 
          ({{ tokenPercentage() }}% de vida)
        </p>
        <p *ngIf="auth.almostExpired()" class="text-warning">
          ⚠️ Token en fase crítica (≤20%)
        </p>
      </div>
    </div>
    <div class="token-stats">
      <div class="stat">
        <label>Vida Total del Ciclo:</label>
        <span>{{ currentTokenLifeSeconds() }}s</span>
      </div>
      <div class="stat">
        <label>Tiempo Transcurrido:</label>
        <span>{{ elapsedSeconds() }}s</span>
      </div>
      <div class="stat">
        <label>Tiempo Restante:</label>
        <span>{{ auth.tokenRemainingSeconds() }}s</span>
      </div>
    </div>
  </section>

  <!-- 7. ACCIONES DE AUTENTICACIÓN -->
  <section class="card">
    <h2>Acciones de Autenticación</h2>
    <sca-alert variant="info">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Métodos públicos del AuthenticationStore
      
    </sca-alert>
    <div class="button-grid">
      <button sca-button
        (click)="auth.login({ interactive: true })"
        [disabled]="auth.isAuthenticating() || auth.logged()">
        <sca-icon icon="login" size="20px" />
        Login Interactivo
      </button>
      
      <button sca-button
        (click)="auth.login({ interactive: false })"
        [disabled]="auth.isAuthenticating() || auth.logged()">
        <sca-icon icon="lock" size="20px" />
        Login Silencioso
      </button>
      
      <button sca-button
        (click)="auth.refresh()"
        [disabled]="!auth.logged() || auth.isRefreshing()">
        <sca-icon icon="refresh" size="20px" />
        Refresh Token
      </button>
      
      <button sca-button
        (click)="auth.logout()"
        [disabled]="!auth.logged()">
        <sca-icon icon="logout" size="20px" />
        Logout
      </button>
    </div>
    
    <div class="action-status">
      <p *ngIf="auth.isAuthenticating()">⏳ Autenticando...</p>
      <p *ngIf="auth.isRefreshing()">🔄 Refrescando token...</p>
    </div>
  </section>

  <!-- 7.5. PRUEBA DE AUTHENTICATION GUARDS -->
  <section class="card">
    <h2>Prueba de Authentication Guards</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Rutas protegidas para probar el funcionamiento de los guards. Los <strong>Authentication Guards</strong> son interceptores que protegen rutas verificando autenticación y roles.
      
    </sca-alert>

    <!-- Grid de tests de guards - Solo 2 cards -->
    <div class="guards-test-grid" style="margin-bottom: 1.5rem;">
      <!-- Test 1: Ruta protegida simple -->
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="lock" size="32px" />
        <span scaCardClaimTitle>Ruta Protegida Simple</span>
        <span scaCardClaimDate>
          Guard: <code>authGuardCanActivate</code><br>
          Requiere: Autenticación<br>
          <button sca-button variant="border" size="small" [routerLink]="['/protected']" style="margin-top: 0.5rem;">
            <sca-icon icon="arrow_forward" size="16px" left />
            Probar
          </button>
        </span>
      </sca-card-claim>

      <!-- Test 2: Ruta con roles -->
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="admin_panel_settings" size="32px" />
        <span scaCardClaimTitle>Verificación de Roles</span>
        <span scaCardClaimDate>
          Guard: <code>authGuardCanMatchFn</code><br>
          Requiere: Autenticación + Roles (ADMIN/USER)<br>
          <button sca-button variant="border" size="small" [routerLink]="['/protected-roles']" style="margin-top: 0.5rem;">
            <sca-icon icon="arrow_forward" size="16px" left />
            Probar
          </button>
        </span>
      </sca-card-claim>
    </div>

    <sca-alert variant="warning">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      <strong>Instrucciones:</strong> Si NO estás autenticado, los guards te redirigirán al login. Si estás autenticado, accederás a la ruta protegida. Para la ruta con roles, necesitas tener ADMIN o USER.
      
    </sca-alert>
  </section>

  <!-- 8. CONFIGURACIÓN DE REFRESH -->
  <section class="card">
    <h2>Configuración de Refresh (AuthRefreshTypesEnum)</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Tipo de auto-refresh configurado en la aplicación
      
    </sca-alert>
    <div class="config-display">
      <sca-card-workshop [selected]="refreshType() === AuthRefreshTypesEnum.BYUSERACTIVITY">
        <header scaCardWorkshopHeader>
          <sca-badge variant="default" [rounded]="false">BYUSERACTIVITY</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Auto-refresh solo con actividad del usuario</p>
        <p scaCardWorkshopAddress>Detecta: click, keypress, wheel, touchmove, mousemove, visibilitychange</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="refreshType() === AuthRefreshTypesEnum.BYCUSTOMACTION">
        <header scaCardWorkshopHeader>
          <sca-badge variant="default" [rounded]="false">BYCUSTOMACTION</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Nunca auto-refresh; requiere llamada manual</p>
        <p scaCardWorkshopAddress>Necesita llamar explícitamente a auth.refresh()</p>
      </sca-card-workshop>
      
      <sca-card-workshop [selected]="refreshType() === AuthRefreshTypesEnum.NOREFRESHABLE">
        <header scaCardWorkshopHeader>
          <sca-badge variant="default" [rounded]="false">NOREFRESHABLE</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Nunca refresca; el token expira</p>
        <p scaCardWorkshopAddress>El usuario debe hacer login nuevamente</p>
      </sca-card-workshop>
    </div>
  </section>

  <!-- 9. GUARDS Y UTILIDADES -->
  <section class="card">
    <h2>Guards y Utilidades (Routing)</h2>
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Funciones para proteger rutas y validar permisos
      
    </sca-alert>
    <div class="utilities-grid">
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="lock" size="24px" />
        <span scaCardClaimTitle>authGuardCanActivate</span>
        <span scaCardClaimDate>Guard para proteger rutas</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="lock" size="24px" />
        <span scaCardClaimTitle>authGuardCanActivateChild</span>
        <span scaCardClaimDate>Guard para rutas hijas</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="lock" size="24px" />
        <span scaCardClaimTitle>authGuardCanDeactivate</span>
        <span scaCardClaimDate>Prevenir abandono de ruta</span>
      </sca-card-claim>
      
      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="lock" size="24px" />
        <span scaCardClaimTitle>authGuardCanMatchFn</span>
        <span scaCardClaimDate>Match condicional de rutas</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="build" size="24px" />
        <span scaCardClaimTitle>getConditions()</span>
        <span scaCardClaimDate>Extraer condiciones de route.data</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="verified_user" size="24px" />
        <span scaCardClaimTitle>hasAllowedRole()</span>
        <span scaCardClaimDate>Verificar roles del usuario</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="check_circle" size="24px" />
        <span scaCardClaimTitle>isRouteAuthenticated()</span>
        <span scaCardClaimDate>Estado de autenticación</span>
      </sca-card-claim>

      <sca-card-claim>
        <sca-icon scaCardClaimIcon icon="http" size="24px" />
        <span scaCardClaimTitle>authInterceptor</span>
        <span scaCardClaimDate>HTTP Interceptor automático</span>
      </sca-card-claim>
    </div>
  </section>

  
  
</div>
